import {
    ChakraProps,
    FormControl,
    FormErrorMessage,
    FormLabel,
    Icon,
    Input,
    InputGroup,
    InputRightElement,
    Text,
} from '@chakra-ui/react';
import { useState } from 'react';
import { MdOutlineRemoveRedEye } from 'react-icons/md';
import { RiEyeCloseLine } from 'react-icons/ri';

type TProps = {
    label: string;
    required?: boolean;
    type?: string;
    placeholder: string;
    value: string | number;
    onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
    name?: string;
    helperText?: string;
    error?: boolean;
    autoComplete?: string;
    onBlur?: any;
    sx?: ChakraProps['sx'];
    disabled?: boolean;
    onChangeValue?: (value: string) => void;
};

const InputMy = ({
    required,
    label,
    type = 'text',
    value,
    onChange,
    placeholder,
    name,
    helperText,
    error,
    autoComplete,
    onBlur,
    sx,
    disabled,
    onChangeValue,
}: TProps) => {
    const [show, setShow] = useState(false);
    const handleShow = () => setShow(!show);

    const _type = type === 'password' && show ? 'text' : type;

    return (
        <FormControl isInvalid={error} sx={sx}>
            <FormLabel display="flex" fontSize="md" fontWeight="700" color="gray.900" mb="8px">
                {label}
                {required && <Text color="red.500">&nbsp;*</Text>}
            </FormLabel>
            <InputGroup size="md">
                <Input
                    onBlur={onBlur}
                    name={name}
                    value={value}
                    onChange={onChangeValue ? e => onChangeValue(e.target.value) : onChange}
                    isRequired={required}
                    variant="auth"
                    fontSize="md"
                    ms={{ base: '0px', md: '0px' }}
                    type={_type}
                    autoComplete={autoComplete}
                    placeholder={placeholder}
                    fontWeight="500"
                    size="lg"
                    disabled={disabled}
                />
                {type === 'password' && (
                    <InputRightElement display="flex" alignItems="center" mt="4px" userSelect="none">
                        <Icon
                            color="gray.900"
                            _hover={{ cursor: 'pointer' }}
                            as={show ? RiEyeCloseLine : MdOutlineRemoveRedEye}
                            onClick={handleShow}
                        />
                    </InputRightElement>
                )}
            </InputGroup>
            <FormErrorMessage
                sx={{
                    fontSize: '14px',
                    fontWeight: '500',
                }}
            >
                {helperText}
            </FormErrorMessage>
        </FormControl>
    );
};

export default InputMy;
